import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { SessionBlockAthleteNoteEntity } from "@/modules/sessions/entities/sessionBlockAthleteNoteEntity"
import { word } from "@modules/core/utils/i18n"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"

type Props = {
  note: SessionBlockAthleteNoteEntity
  displayDetailedEvents: boolean
  className?: string
} & React.ComponentProps<"div">

export function NoteForAthletesInEvent({ note, displayDetailedEvents, className, ...props }: Props) {
  return (
    <div className={cn("flex flex-col gap-1", className)} {...props}>
      <Text fontStyle="LS" className="text-textDefault-body uppercase">
        {word("sessionForm.blocks.note_for_athletes")}
      </Text>
      <HURichTextView
        value={formatTextToRichText(note.note)}
        paragrapheFontStyle="BS"
        numberOfLine={displayDetailedEvents ? undefined : 3}
        className="italic"
      />
    </div>
  )
}
